import { TransformComponent, TransformWrapper, useControls } from 'react-zoom-pan-pinch';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './styles.zoomViewer';

const Controls = ({ pathImage }: { pathImage: string }) => {
  const { zoomIn, zoomOut } = useControls();
  const { translate } = useI18nContext();
  const { toggleModal, setContentModal, defineTitleModal, handleCustomSizeModal } = useModalContext();

  const isDesktop = window.innerWidth > 768;

  const handleOpenModal = () => {
    if (isDesktop) handleCustomSizeModal({ width : 80, height : 80 });

    setContentModal(<ZoomImageViewer pathImage={pathImage} />);
    defineTitleModal(translate(['MAP']));
    toggleModal({ open : true });
  };

  return (
    <Styles.Controls id="zoom-controls">
      <Styles.ExpandButton onClick={handleOpenModal} id="zoom-out-button">
        Expandir mapa
      </Styles.ExpandButton>
      <Styles.ButtonControl onClick={() => zoomOut()} id="zoom-out-button">
        <img src={ImagesApp.svg.minus} alt="Remove zoom" id="zoom-out-icon" />
      </Styles.ButtonControl>
      <Styles.ButtonControl onClick={() => zoomIn()} id="zoom-in-button">
        <img src={ImagesApp.svg.more} alt="Add zoom" id="zoom-in-icon" />
      </Styles.ButtonControl>
    </Styles.Controls>
  );
};

const ZoomImageViewer = ({ pathImage }: { pathImage: string }) => {<div className=""></div>;

  const isDesktop = window.innerWidth > 768;
  const { modalIsOpen } = useModalContext();

  return (
    <TransformWrapper
      initialScale={1}
      initialPositionX={(modalIsOpen && isDesktop) ? 480 : 0}
      initialPositionY={0}
      minScale={0.5}
      maxScale={4}
    >
      <Controls pathImage={pathImage} />
      <TransformComponent
        wrapperStyle={{
          width : '100%',
          height : '100%',
        }}
      >
        <Styles.ContainerImage id="zoom-image-viewer">
          <img src={pathImage}
            id="start-image-event"
            alt="start image event"/>
        </Styles.ContainerImage>
      </TransformComponent>
    </TransformWrapper>
  );
};

export default ZoomImageViewer;
